import React, { useEffect, useState } from 'react'
import './Blogs.css'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import { GetLocalStorageParsed } from '../utils/page'
import BlogsComponent from '../../Components/BlogsComponent/BlogsComponent'
import BlogsReadMore from '../../Components/BlogsComponent/BlogsReadMore'

const Blogs = () => {
const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

        <Header setLoginToken={setLoginToken}
        />
        <BlogsComponent/>
        <Footer />
      </div>
    </>
  )
}

export default Blogs

